import graphql from 'babel-plugin-relay/macro'
import CompanyContext from 'context/CompanyContext'
import React from 'react'
import { useHistory } from 'react-router-dom'
import { Table } from 'semantic-ui-react'
import CompanyBadgeStatus from './badges/CompanyBadgeStatus'

graphql`
  fragment CompanyTable_company on Company @relay(mask: false) {
    id
    code
    name
    abbr
    establishmentCode
    taxName
    isDisabled
  }
`

export default function CompanyTable() {
  const { companies } = React.useContext(CompanyContext)
  const history = useHistory()

  return (
    <Table selectable celled>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell collapsing>
            <i className="fas fa-hashtag" style={{ marginRight: '8px', opacity: 0.7 }} />
            Código
          </Table.HeaderCell>
          <Table.HeaderCell>
            <i className="fas fa-file-invoice" style={{ marginRight: '8px', opacity: 0.7 }} />
            Nombre del Emisor
          </Table.HeaderCell>
          <Table.HeaderCell>
            <i className="fas fa-building" style={{ marginRight: '8px', opacity: 0.7 }} />
            Nombre
          </Table.HeaderCell>
          <Table.HeaderCell>
            <i className="fas fa-tag" style={{ marginRight: '8px', opacity: 0.7 }} />
            Abreviatura
          </Table.HeaderCell>
          <Table.HeaderCell>
            <i className="fas fa-code" style={{ marginRight: '8px', opacity: 0.7 }} />
            Código de Establecimiento
          </Table.HeaderCell>
          <Table.HeaderCell>
            <i className="fas fa-info-circle" style={{ marginRight: '8px', opacity: 0.7 }} />
            Estado
          </Table.HeaderCell>
        </Table.Row>
      </Table.Header>

      <Table.Body>
        {companies.map(company => (
          <Table.Row
            key={company.id}
            onClick={() => history.push(`/company/${company.id}`)}
            style={{ cursor: 'pointer' }}
          >
            <Table.Cell>{company.code}</Table.Cell>
            <Table.Cell>{company.taxName}</Table.Cell>
            <Table.Cell>{company.name}</Table.Cell>
            <Table.Cell>{company.abbr}</Table.Cell>
            <Table.Cell>{company.establishmentCode}</Table.Cell>
            <Table.Cell>
              <CompanyBadgeStatus status={company.isDisabled} />
            </Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  )
}
